import { CurtainValue } from 'redux/slices/curtain'
export const isCurtainOpen = (state: CurtainValue) => state === CurtainValue.OPEN
export const isCurtainClosed = (state: CurtainValue) => state === CurtainValue.CLOSED
export const isCurtainClosing = (state: CurtainValue) => state === CurtainValue.CLOSING
